export const ItemTypes = {
  SECTION: 'section',
} as const;
